import { createThunkRequest, GET, POST } from '@webapp/account/src/libs/request';

import type { MailSettings } from './mailing';

export const getMailSettings = createThunkRequest(
    'settings/getMailSettings',
    async () => {
        const { data } = await POST('show/user_settings', {
            type: 'mail',
        });

        return {
            mailSettings: Array.isArray(data) || !data ? {} : data,
        };
    },
    { notify: false },
);

export const saveMailSettings = createThunkRequest(
    'settings/saveMailSettings',
    async ({ mailSettings }: { mailSettings: Partial<MailSettings> }) => {
        const { message } = await POST('change/user_settings', {
            type: 'mail',
            data: mailSettings,
        });

        return {
            mailSettings,
            message,
        };
    },
);

export const getSmsSettings = createThunkRequest(
    'settings/getSmsSettings',
    async () => {
        const { data } = await POST('show/user_settings', {
            type: 'sms',
        });

        return data;
    },
    { notify: false },
);

export const getUserSettings = createThunkRequest(
    'settings/getUserSettings',
    async ({ type }: { type: string }) => {
        const { data } = await POST('show/user_settings', { type });

        return { type, data: typeof data === 'string' ? JSON.parse(data) : data };
    },
    { notify: false },
);

export const saveUserSettings = createThunkRequest(
    'settings/saveSettings',
    async ({ type, data, mainUser }: { type: string; data: any; mainUser?: boolean }) => {
        const { message } = await POST('change/user_settings', {
            type,
            mainUser,
            data,
        });

        return {
            type,
            data,
            message,
        };
    },
);

export const getChartsData = createThunkRequest(
    'settings/getChartsData',
    async ({ surveyId }: { surveyId: string }) => {
        const { data } = await GET('get/charts_data', { surveyId });

        return { type: 'charts', data: typeof data === 'string' ? JSON.parse(data) : {} };
    },
    { notify: false },
);
